import { makeStyles } from '@mui/styles';
import { Colors } from '../../../../theme/colors';

export const useEntityHistoryControlsStyles = makeStyles({
  wrapper: {},
  datePicker: {
    '& .MuiPickersInputBase-root': {
      fontSize: '13px'
    },
    maxWidth: '200px'
  },
  calendarIcon: {
    fontSize: '18px',
    color: Colors.timelineGray
  }
});
